Wee.fn.make('resources', {
	init: function() {
		this.$private.initEvents();
	},

	unload: function() {
		$.events.off(false, '.resourcesSort');
	}
}, {
	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:resourcesToggle': {
				click: function(e, el) {
					$(el).next().isDisabled() ? scope.enableDropdown(el) : scope.disableDropdown(el);
					e.stopPropagation();
				}
			},

			'ref:resourcesOption': {
				click: function(e, el) {
					var $el = $(el);

					$('ref:resourcesSelection').val($el.attr('data-value'));

					scope.search();
				}
			},

			'ref:resourcesSearch': {
				submit: function(e) {
					scope.search();

					e.preventDefault();
				}
			},

			'body': {
				click: function() {
					$('ref:resourcesList').disable();
					$('ref:resourcesFilter').deactivate();
				}
			}
		}, {
			namespace: 'resourcesSort'
		});
	},

	/**
	 * Serialize form data, filter empty query values, and build URL path
	 *
	 * @private
	 */
	search: function() {
		var $form = $('ref:resourcesSearch'),
			formData = $form.serialize(true),
			filteredData = {},
			queryChar;

		for (var item in formData) {
			if (formData.hasOwnProperty(item)) {
				if (formData[item] !== '') {
					filteredData[item] = formData[item];
				}
			}
		}

		if ($.routes.uri().segments.length > 1) {
			$.history.go({
				path: '/resources' + '?' + $.serialize(filteredData)
			});
		} else {
			$.history.go({
				path: $.routes.uri().path + '?' + $.serialize(filteredData)
			});
		}
	},

	/**
	 * Enable News Category dropdown
	 *
	 * @private
	 */
	enableDropdown: function(el) {
		var $el = $(el);

		$el.closest('ref:resourcesFilter').activate();
		$el.next('ref:resourcesList').enable();
		$el.activate().attr('aria-hidden', false);
	},

	/**
	 * Disable News Category dropdown
	 *
	 * @private
	 */
	disableDropdown: function(el) {
		var $el = $(el);

		$el.closest('ref:resourcesFilter').deactivate();
		$el.next('ref:resourcesList').disable();
		$el.deactivate().attr('aria-hidden', true);
	}
});